import React from 'react';
import { withTranslation } from 'react-i18next/hooks';

import theme from '../../../theme';

import {Dialog, DialogActions, DialogContent, DialogTitle, Typography, OutlinedInput} from '@material-ui/core'

import {Table, TableBody, TableCell, TableHead, TableRow}  from '@material-ui/core';
import {Paper, IconButton, Menu, MenuItem, ListItemIcon, ListItemText} from '@material-ui/core';

import {Button, Checkbox} from '@material-ui/core';

import MoreVert from '@material-ui/icons/MoreVert';
import EditIcon from '@material-ui/icons/Edit';

import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';

import { getBase64ID, getIndexByID, getObjectByID, sortByName } from '../../../api/helpers';
import { GroupPatchDialog } from './GroupPatchDialog';


class GroupPatchesDialog_ extends React.Component {

    constructor(props){
        super(props)


        this.state = {
            groupPatches: [...this.props.groupPatches],
            selectedID: null,
            groupPatchDialog:{
                open: false,
                groupPatch: null
            }
        }

        this.onAction = this.onAction.bind(this)
        this.handleMenuClick = this.handleMenuClick.bind(this)
        this.setGroupPatchState = this.setGroupPatchState.bind(this)
    }

    handleClose(){
        if(this.state.changed){
            if(!window.confirm(this.props.t('CloseFormConfirm'))) return; 
        }
        this.props.onAction({type: 'GROUP_PATCHES_DIALOG_CLOSE'})
    }

    handleMenuClick(event, itemID){
        this.setState({menuAnchor: event.currentTarget, menuItemID: itemID});
        event.stopPropagation();
    }

    handleMenuClose(){
        this.menuAnchor = null;
        this.setState({menuAnchor: null});
        return null;
    }

    setGroupPatchState(event, groupPatch){
        console.log('setGroupPatchState')
        console.log(event.target.checked)
        console.log(groupPatch)

        let index = getIndexByID(groupPatch.ID, this.state.groupPatches)
        groupPatch.Enabled = event.target.checked

        this.props.onAction({type:'GROUP_PATCH_UPDATE', groupPatch: groupPatch, op: 2})//op=2 update

        this.setState()
    }

    handleSelect(ID){
        this.setState({selectedID: ID})
    }

    getStyle(ID){
        let selected = ID === this.state.selectedID
        let style = {
            background: selected ? theme.palette.background.selectedRow : '',
            cursor: 'pointer'
        }
        return style
    }

    handleMenuItemClick(action){
        const itemID = this.state.menuItemID
        const groupPatch = getObjectByID(itemID, this.state.groupPatches)
        this.handleMenuClose();
        this.onAction({type: action, groupPatchID: itemID, groupPatch: groupPatch})
    }

    onAction(action){

        switch(action.type){


            case 'GROUP_PATCH_EDITOR_OPEN_ADD':{
                let dialog = this.state.groupPatchDialog
                dialog.open = true
                dialog.groupPatch = null
                this.setState({groupPatchDialog: dialog})
                break
            } 

            case 'GROUP_PATCH_EDITOR_OPEN_EDIT':{
                let groupPatch = getObjectByID(this.state.menuItemID, this.state.groupPatches)
                if(groupPatch){
                    let dialog = this.state.groupPatchDialog
                    dialog.open = true
                    dialog.groupPatch = groupPatch
                    this.setState({groupPatchDialog: dialog})
                }
                break
            }

            case 'GROUP_PATCH_DIALOG_CLOSE':{
                let dialog = this.state.groupPatchDialog
                dialog.open = false
                dialog.groupPatch = null
                this.setState({groupPatchDialog: dialog})
                break
            }

            case 'GROUP_PATCH_DIALOG_SAVE':{
                console.log('action GROUP_PATCH_DIALOG_SAVE')
                console.log(action)

                let op
                let groupPatch = action.groupPatch
                let groupPatches = this.state.groupPatches
                if(groupPatch.ID){
                    op = 2
                    let index = getIndexByID(groupPatch.ID, groupPatches)
                    groupPatches[index] = groupPatch
                }else{
                    groupPatch.ID = getBase64ID()
                    op = 1
                    groupPatches.push(groupPatch)
                }

                this.props.onAction({type: 'GROUP_PATCH_UPDATE', groupPatch: groupPatch, op: op})

                let dialog = this.state.groupPatchDialog
                dialog.open = false
                dialog.groupPatch = null
                this.setState({groupPatchDialog: dialog, groupPatches: groupPatches})

                break
            }

            case 'GROUP_PATCH_EDITOR_DELETE':{
                console.log('action GROUP_PATCH_EDITOR_DELETE')
                console.log(action)

                //let dialog = this.state.groupPatchDialog
                //dialog.open = false
                //dialog.groupPatch = null
                
                let groupPatches = this.state.groupPatches
                let index = getIndexByID(action.groupPatch.ID, this.state.groupPatches)
                if(index) groupPatches.splice(index, 1)

                this.props.onAction({type: 'GROUP_PATCH_UPDATE', groupPatch: action.groupPatch, op: 3})

                this.setState({groupPatches: groupPatches})

                break
            }

            case 'GENERATE_NEW_NAME':{

                let i = 0 
                while(true){
                    let new_name = this.generate_name(i)

                    let exist = false

                    for(var j=0; j<this.state.groupPatches.length; j++ ){

                        let groupPatch = this.state.groupPatches[j]
                        if(new_name===groupPatch.Name) exist = true
                    }
                        
                    if(!exist) return new_name
                        
                    i++
                }
            }


            default: alert('GroupPatchesDialog: onAction case '+action.type)

        }
    }

    generate_name(i){
        return this.props.t('GroupPatch') + (i>0 ? ' '+i : '')
    }

    render(){
        const {t} = this.props

        const title = t('GroupPatches')

        const styles = {
            paper: {
              width: '100%',
              overflowX: 'auto',
            },
            head: {
                color: theme.palette.color.dialogTitle,
                backgroundColor: theme.palette.background.dialogTitle,
            },
            addIcon: {
                color: 'white'
            }
        };


        this.props.groupPatches.sort(sortByName)

        return(
<Dialog
    scroll="body"
    fullWidth={this.props.fullWidth}
    maxWidth={this.props.maxWidth}
    open={this.props.open}
    onClose={this.handleClose.bind(this)}
    aria-labelledby="edit-dialog-title">
        
    <DialogTitle id="edit-dialog-title">{title}</DialogTitle>

    <DialogContent style={{minWidth:450}}>
        <Paper style={styles.paper}>
            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell style={styles.head}>{t('Name')}</TableCell>
                        <TableCell style={styles.head}>{t('Enabled')}</TableCell>
                        <TableCell style={{...styles.head, width:40}}>
                            <IconButton size="small" color="primary" aria-label="more" component="span"
                                style={styles.addIcon}
                                onClick={()=>{this.handleMenuItemClick('GROUP_PATCH_EDITOR_OPEN_ADD')}}>
                                <AddCircleOutlineIcon />
                            </IconButton>
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                {this.state.groupPatches.map((groupPatch) => 
                    <TableRow key={groupPatch.ID} 
                            onClick={()=>{this.handleSelect(groupPatch.ID)}}
                            style={this.getStyle(groupPatch.ID)}>
                        <TableCell component="th" scope="row">
                            {groupPatch.Name}
                        </TableCell>
                        <TableCell component="th" scope="row">
                            <Checkbox 
                                onChange={(event)=>this.setGroupPatchState(event, groupPatch)}
                                checked={groupPatch.Enabled}></Checkbox>
                        </TableCell>
                        <TableCell style={{width:40}}>
                            <IconButton size="small" color="inherit" aria-label="add" component="span"
                                onClick={event=>this.handleMenuClick(event, groupPatch.ID)}>
                                <MoreVert />
                            </IconButton>
                        </TableCell>
                    </TableRow>
                )}
                </TableBody>
                <Menu anchorEl={this.state.menuAnchor} keepMounted
                    open={Boolean(this.state.menuAnchor)} onClose={this.handleMenuClose.bind(this)}>
                    <MenuItem onClick={()=>{this.handleMenuItemClick('GROUP_PATCH_EDITOR_OPEN_EDIT')}}>
                        <ListItemIcon color="primary"><EditIcon/></ListItemIcon> 
                        <ListItemText primary={t('EditGroupPatch')+'...'} />
                    </MenuItem>
                    <MenuItem onClick={()=>{this.handleMenuItemClick('GROUP_PATCH_EDITOR_DELETE')}}>
                        <ListItemIcon><DeleteForeverIcon/></ListItemIcon>
                        <ListItemText primary={t('DeleteGroupPatch')} />
                    </MenuItem>
                </Menu>
            </Table>
        </Paper>
    </DialogContent>

    <DialogActions>
        <Button onClick={this.handleClose.bind(this)} variant="contained" color="inherit">
            {t('Close')}
        </Button>
    </DialogActions>


    {this.state.groupPatchDialog.open ? 
        <GroupPatchDialog 
            {...this.state.groupPatchDialog}
            onAction={this.onAction}
            networks={this.props.networks}
             /> 
    :''}

</Dialog>
        );

    }


}


export const GroupPatchesDialog = withTranslation()(GroupPatchesDialog_);